export const SET_SPLASH_SCREEN_VISIBLE = "SET_SPLASH_SCREEN_VISIBLE";
export const SET_LOGOUT_TOAST = "SET_LOGOUT_TOAST";
